import styled from "styled-components";
import {LOBBY_PAGE} from "../../../themes/css-global-classes";

export const SeoBreadcrumbsContainerBox = styled.div`
    .${LOBBY_PAGE} &{
        @media ${({theme}) => theme.mediaQuery.mAndAbove} {
            margin-top: 55px;
        }
    }
`;